/* eslint-disable pii/no-phone-number */
import React from "react";
import PropTypes from "prop-types";
import { reduxForm, formValueSelector } from "redux-form";
import { connect } from "react-redux";
import { Button } from "cxa-components";
import { CheckboxField } from "cxa-form-field";
import { isExist } from "cxa-utils";
import StyledForm from "./StyledForm";
import { validateForm, validateRequired } from "../validation";
import { SUBMIT_FAILURE_MESSAGE } from "../../constants";
import enhance from "../../hoc";

const PRUDENTIAL_HDF_ID = "prudentialHdf202101";

const PrudentialHdf = props => {
  const {
    handleSubmit,
    submitting,
    confirm,
    prudentialForm,
    isReadOnly,
    renderValue,
    onSave,
    onPrint,
    onClose,
  } = props;

  const handleSave = onSave(PRUDENTIAL_HDF_ID);
  const isSubmitFailed = isExist(prudentialForm) && prudentialForm.submitFailed;

  return (
    <div className="hdf">
      <div className="aligner hdf-header">
        <div className="aligner-column aligner__item--top" style={{ flex: "0 0 300px" }}>
          <img
            src="/assets/images/hdf/prudential-logo.svg"
            className="logo"
            alt="Pudential HDF"
            width="250px"
          />
          <h2 style={{ fontSize: "18px" }}>Group Health Declaration</h2>
        </div>
        <div className="aligner__item--top hdf-table">
          <table className="for-official-table">
            <tbody>
              <tr>
                <td rowSpan={2} />
                <td colSpan={3}>FOR OFFICE USE ONLY</td>
              </tr>
              <tr>
                <td>GTL/TPD</td>
                <td>GCCE/GCCA</td>
                <td>GDI</td>
              </tr>
              <tr>
                <td style={{ textAlign: "left" }}>Sum Assured</td>
                <td />
                <td />
                <td />
              </tr>
              <tr>
                <td style={{ textAlign: "left" }}>Free Cover Limit</td>
                <td />
                <td />
                <td />
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <p className="border--red red-text bold-text" style={{ fontSize: "12px" }}>
        WARNING: YOU ARE REQUIRED TO FULLY AND FAITHFULLY DISCLOSE ALL THE FACTS THAT YOU KNOW OR
        OUGHT TO KNOW. OTHERWISE, YOUR INSURANCE COVERAGE PROVIDED UNDER THIS PLAN MAY BE VOID.
      </p>

      <StyledForm renderValue={renderValue} {...props} />

      <div className="border--red">
        <p className="bold-text">
          Consent, Declaration and Authorisation -Please read carefully before signing this Group
          Health Declaration Form.
        </p>
        <p>
          I consent to Prudential Assurance Company (Pte) Limited {'("Prudential")'}, its officers
          and employees:{" "}
        </p>
        <p className="subitem">
          a) Collecting and using at their sole discretion any and all information relating to me,
          including my personal particulars, in this Group Health Declaration for the purposes of
          underwriting; and
        </p>
        <p className="subitem">
          b) Disclosing at their sole discretion any and all information relating to me, including
          my personal particulars, in this Group Health Declaration to the servicing intermediary
          for the above group policy for the purpose of customer service.
        </p>
        <p>
          I declare that no material facts, that are facts likely to influence the assessment and
          acceptance of my group application, have been withheld and the Information given above is
          true and complete and best to my knowledge and they shall be the basis of the issuance of
          my group insurance coverage.
        </p>
        <p>
          I agree to inform Prudential if there is any change in the state of my health/activity
          between the date of this Health Declarationor medical examination and the date of full
          insurance coverage is provided by Prudential to me. I understand that the terms of
          accepting me as a risk for insurance coverage may vary according to such information
          received.
        </p>
        <p>
          I agree and authorize any medical source (i.e. physician and hospital), insurance office
          or organization that has my records to release to Prudential any relevant information at
          anytime for the purpose of underwriting this group application. A photographic copy of
          this authorization shall be as valid as the original.
        </p>
        <p>
          {[
            'I further declare that I have read and understood the "Your ',
            'Guide To Health Insurance" and "Product Summary" (applicable to ',
            "voluntary coverage only).",
          ].join("")}
        </p>
        <CheckboxField validate={validateRequired} name="declaration" id="declaration">
          <strong>I have read and accept this declaration</strong>
        </CheckboxField>
      </div>
      <table style={{ marginTop: "8px" }}>
        <tr>
          <td style={{ width: "200px", height: "100px" }}>
            <div>
              Signature of <span className="bold-text">Employee</span>
            </div>
          </td>
          <td />
        </tr>
        <tr>
          <td>
            <div>
              <span className="bold-text">Date</span> Declared
            </div>
          </td>
          <td />
        </tr>
      </table>
      <div
        style={{
          borderTop: "1px solid",
          paddingTop: "8px",
        }}
      >
        <p className="text--center">
          <div className="bold-text">
            Prudential Assurance Company Singapore (Pte) Limited (Reg. No. 199002477Z)
          </div>
          Ops Division -Enterprise SolutionsAddress: Singapore Post Centre Post Office PO Box 399
          Singapore 914014
          <br />
          Email:{" "}
          <a href="mailto:SGP.ES.Medicalunderwriting@prudential.com.sg">
            SGP.ES.Medicalunderwriting@prudential.com.sg
          </a>
        </p>
        <p className="text--left">ESHD Jun 2019 (EO)</p>
      </div>

      {isSubmitFailed && (
        <p role="alert" className="card--alert">
          {SUBMIT_FAILURE_MESSAGE}
        </p>
      )}

      <div className="form__actions">
        {!isReadOnly ? (
          [
            <Button key="save" onClick={handleSave} disabled={submitting} secondary>
              Save
            </Button>,
            <Button
              primary
              key="submit"
              submitting={submitting}
              onClick={handleSubmit(confirm)}
              disabled={submitting}
            >
              Submit & Confirm
            </Button>,
          ]
        ) : (
          <Button primary onClick={onPrint}>Print</Button>
        )}

        <Button onClick={onClose} disabled={submitting} secondary>
          Close
        </Button>
      </div>
    </div>
  );
};

PrudentialHdf.propTypes = {
  employeeParticulars: PropTypes.object,
  handleSubmit: PropTypes.func,
  submitting: PropTypes.bool,
  save: PropTypes.func,
  confirm: PropTypes.func,
  prudentialForm: PropTypes.object,
  isReadOnly: PropTypes.bool,
  renderValue: PropTypes.func,
  onSave: PropTypes.func,
  onPrint: PropTypes.func,
  onClose: PropTypes.func,
};

let PrudentialHdfFrom = reduxForm({
  form: PRUDENTIAL_HDF_ID,
  enableReinitialize: true,
  validate: validateForm,
})(PrudentialHdf);

// Decorate with connect to read form values
const selector = formValueSelector(PRUDENTIAL_HDF_ID);
PrudentialHdfFrom = connect(state => {
  const isAdventurePrivateFlyingChecked = selector(state, "AdventurePrivateFlying");
  const isAdventureScubaDivingChecked = selector(state, "AdventureScubaDiving");
  const isMountaineeringChecked = selector(state, "Mountaineering");
  const isAdventureParachutingChecked = selector(state, "AdventureParachuting");
  const isAdventureRacingChecked = selector(state, "AdventureRacing");
  const isAdventureOtherExtremeChecked = selector(state, "AdventureOtherExtreme");

  const isQ1FieldsRequired =
    isAdventurePrivateFlyingChecked === "Yes" ||
    isAdventureScubaDivingChecked === "Yes" ||
    isMountaineeringChecked === "Yes" ||
    isAdventureRacingChecked === "Yes" ||
    isAdventureParachutingChecked === "Yes" ||
    isAdventureOtherExtremeChecked === "Yes";

  const isDrugAddictionChecked = selector(state, "DrugAddiction");
  const isExclusionsChecked = selector(state, "Exclusions");
  const isWeightLossChecked = selector(state, "WeightLoss");
  const isSmokeChecked = selector(state, "Smoke");
  const isAlcoholChecked = selector(state, "Alcohol");
  const isSexualDiseaseChecked = selector(state, "SexualDisease");
  const isDiagnosisInfoChecked = selector(state, "DiagnosisInfo");
  const isFamilyHistoryChecked = selector(state, "FamilyHistory");

  const isPapSmearChecked = selector(state, "PapSmear");
  const isGynaecologicalChecked = selector(state, "Gynaecological");
  const isMenstruationDisorderChecked = selector(state, "MenstruationDisorder");
  const isComplicationOfPregnancyChecked = selector(state, "ComplicationOfPregnancy");
  const isPregnantChecked = selector(state, "Pregnant");

  const isLungDisorderChecked = selector(state, "LungDisorder");
  const isMentalDisordersChecked = selector(state, "MentalDisorders");
  const isBowelDisorderChecked = selector(state, "BowelDisorder");
  const isKidneyDisorderChecked = selector(state, "KidneyDisorder");
  const isBloodDisorderChecked = selector(state, "BloodDisorder");
  const isCancerChecked = selector(state, "Cancer");
  const isHearingAndSightChecked = selector(state, "HearingAndSight");
  const isGallbladderDisorderChecked = selector(state, "GallbladderDisorder");
  const isPhysicalInjuryChecked = selector(state, "PhysicalInjury");
  const isHeartDisorderChecked = selector(state, "HeartDisorder");
  const isPhysicalDisabilityChecked = selector(state, "PhysicalDisability");

  const isQ11FieldsRequired =
    isLungDisorderChecked === "Yes" ||
    isMentalDisordersChecked === "Yes" ||
    isBowelDisorderChecked === "Yes" ||
    isKidneyDisorderChecked === "Yes" ||
    isBloodDisorderChecked === "Yes" ||
    isCancerChecked === "Yes" ||
    isHearingAndSightChecked === "Yes" ||
    isGallbladderDisorderChecked === "Yes" ||
    isPhysicalInjuryChecked === "Yes" ||
    isHeartDisorderChecked === "Yes" ||
    isPhysicalDisabilityChecked === "Yes";

  return {
    isQ1FieldsRequired,
    isOtherExtremeSportFieldRequired: isAdventureOtherExtremeChecked === "Yes",
    isQ2FieldsRequired: isDrugAddictionChecked === "Yes",
    isQ3FieldsRequired: isExclusionsChecked === "Yes",
    isQ4FieldsRequired: isWeightLossChecked === "Yes",
    isQ5FieldsRequired: isSmokeChecked === "Yes",
    isQ6FieldsRequired: isAlcoholChecked === "Yes",
    isQ7FieldsRequired: isSexualDiseaseChecked === "Yes",
    isQ8FieldsRequired: isDiagnosisInfoChecked === "Yes",
    isQ9FieldsRequired: isFamilyHistoryChecked === "Yes",
    isQ10aFieldsRequired: isPapSmearChecked === "Yes",
    isQ10bFieldsRequired: isGynaecologicalChecked === "Yes",
    isQ10cFieldsRequired: isMenstruationDisorderChecked === "Yes",
    isQ10dFieldsRequired: isComplicationOfPregnancyChecked === "Yes",
    isQ10eFieldsRequired: isPregnantChecked === "Yes",
    isPregnantMonthFieldRequired: isPregnantChecked === "Yes",
    isQ11FieldsRequired,
  };
})(PrudentialHdfFrom);

export default enhance(PrudentialHdfFrom);



// WEBPACK FOOTER //
// ./components/employee/hdf-forms/Prudential/Form202101/index.js